module.exports = __webpack_public_path__ + "static/media/bhavnagar.83018f44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/bhavnagar.jpg
// module id = 1001
// module chunks = 0